import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';

/**
 * DELETE /api/eraf/integration-hub/endpoints/{id} — 엔드포인트 soft-delete (INTEGRATION_MANAGE)
 */
export function useDeleteEndpoint() {
  const queryClient = useQueryClient();
  return useMutation<void, { code: string; message: string }, number>({
    mutationFn: (id) => integrationHubApi.deleteEndpoint(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'endpoints'] });
    },
  });
}
